import styled from 'styled-components';
import { getColor, getColorShade, getSizeBy, getThemeProp } from '../../../../src/styled/utils';
import { Body2Styles, Body1Styles } from '../../typography';
export const PopperContainer = styled.div `
  /* stylelint-disable selector-class-pattern */
  --border-radius: ${({ theme }) => getThemeProp('borderRadius')({ theme })}px;

  & *:focus-visible {
    outline: none;
  }

  .react-datepicker-popper[data-placement^='bottom'] {
    padding-top: ${getSizeBy(0.5)};
  }

  .react-datepicker-popper[data-placement^='top'] {
    padding-bottom: ${getSizeBy(0.5)};
  }

  .react-datepicker-popper[data-placement^='left'] {
    padding-right: ${getSizeBy(0.5)};
  }

  .react-datepicker-popper[data-placement^='right'] {
    padding-left: ${getSizeBy(0.5)};
  }

  .react-datepicker__header {
    padding: 0;
    background-color: initial;
    border-bottom: none;
    border-radius: 0;
  }

  .react-datepicker__month-container {
    width: 100%;
  }

  .react-datepicker__header.react-datepicker__header--time {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${getSizeBy(11)};
    text-align: center;
    border-bottom: 1px solid ${getColorShade('onSurface', 'outline')};
  }

  .react-datepicker-time__header {
    ${Body1Styles};
    color: ${getColor('onSurface')};
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__month-text,
  .react-datepicker__quarter-text,
  .react-datepicker__year-text,
  .react-datepicker__time-name {
    ${Body2Styles};
    display: inline-block;
    margin: 0;
    color: ${getColor('onSurface')};
    line-height: ${getSizeBy(7)};
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background-color: initial;
    border-radius: var(--border-radius);
    outline: 1px solid ${getColorShade('onSurface', 'outline')};
  }

  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    color: ${getColorShade('onSurface', 'outline')};
    cursor: default;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    display: flex;
    gap: ${getSizeBy(1.5)};
    justify-content: space-between;
    width: 100%;

    & > * {
      flex-grow: 1;
    }
  }

  .react-datepicker__day-names {
    margin-top: ${getSizeBy(3)};
    padding: 0 ${getSizeBy(3)};
  }

  .react-datepicker__day-name {
    line-height: ${getSizeBy(4)};
  }

  .react-datepicker__month {
    margin: 0 ${getSizeBy(3)} ${getSizeBy(3)};
    padding-top: ${getSizeBy(3)};
  }

  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    background-color: ${getColorShade('onSurface', 'hover')};
    border-radius: var(--border-radius);
  }

  .react-datepicker__day--disabled:hover,
  .react-datepicker__month-text--disabled:hover,
  .react-datepicker__quarter-text--disabled:hover,
  .react-datepicker__year-text--disabled:hover {
    background-color: initial;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    ${Body1Styles};
    color: ${getColor('primary')};
    line-height: ${getSizeBy(7)};
    background-color: ${getColorShade('primary', 'selected')};
    border-radius: var(--border-radius);
  }

  .react-datepicker__day--outside-month {
    color: ${getColorShade('onSurface', 'outline')};
  }

  .react-datepicker__time-container .react-datepicker__time {
    background-color: initial;
    border-radius: 0;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    ${Body2Styles};
    padding: ${getSizeBy()} 0;
    color: ${getColor('onSurface')};
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    ${Body1Styles};
    color: ${getColor('primary')};
    background-color: ${getColorShade('primary', 'selected')};
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item:hover {
    background-color: ${getColorShade('onSurface', 'hover')};
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: ${getColorShade('onSurface', 'outline')};
    cursor: default;
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled:hover {
    background-color: initial;
  }

  .react-datepicker__year-wrapper {
    max-width: ${getSizeBy(48)};
  }
`;
